<template>
  <div>
    <b-form class="form user-settings">
      <b-row>
        <b-col cols="12">
          <!-- Note Color Selection -->
          <b-form-group description="Choose the color of your general notes.">
            <label>Methodology:</label>
            <b-form-select
              id="match-groups"
              v-model="settingsUser.noteColor"
              :options="toDoMethodologiesJSON"
              @change="handleSettingsUserChange"
            />
          </b-form-group>

          <!-- May not be needed -->
          <b-form-group
            v-if="false"
            description="How long photo shall wait before transitioning?"
          >
            <label>Interval (sec):</label>
            <b-form-spinbutton
              id="match-size"
              v-model="settingsUser.interval"
              :min="intervalMin"
              :max="intervalMax"
              @change="handleSettingsUserChange"
            />
          </b-form-group>
          <b-form-group
            label="Modify Optional fields and displays"
            description="These are the key fields for you to tracking during your call.
               The more fields filled in will provide a more comprehensive search and analysis. "
          >
            <toggles-form
              :data-array="toggles"
              @toggles-change="handleToggleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ResourceBlockSettings from "@/mixins/resourceBlocks/Settings";
import toDoMethodologiesJSON from "../../assets/json/toDoMethodologies.json";

import ItemStore from "@/components/blockResources/_components/itemStore";
import ItemAddImage from "@/components/blockResources/_components/itemAddImage";
import ItemsSidebarSettings from "@/components/blockResources/_components/itemsSideBar";
import storeItemsAudioJSON from "../../assets/json/storeItemsSongs.json";
import DefaultPlayList from "@/components/blockResources/resourcePlayList/assets/json/defaultPlayList.json";
export default {
  name: "Settings_CallLog",
  components: {
    ItemStore,
    ItemAddImage,
    ItemsSidebarSettings
  },
  mixins: [ResourceBlockSettings],
  computed: {
    ...mapGetters({
      apps: "user/apps",
      userData: "user/appsData"
    }),
    /* DATA */
    userDataPhotos() {
      return this.userData &&
        this.userData &&
        this.userData[`app_${this.resource.toolId}`] &&
        this.userData[`app_${this.resource.toolId}`].photos
        ? this.userData[`app_${this.resource.toolId}`].photos
        : DefaultPlayList;
    }
  },
  methods: {
    getListTools() {
      this.$store.dispatch("tools/getListTools").then(resources => {});
    },
    handleImageItems(photos) {
      let photoItems = {
        photos: photos
      };

      let notif = {
        //create message
        title: `${photos.length} Memories Added`,
        description: "Congrats you have updated your family playlist",
        variant: "success"
      };
      const payload = {
        userData: photoItems,
        notif: notif,
        key: "photos"
      };
      this.handleUpdateUserData(payload);
    },
    handleShowPlayListClick() {
      //inside of sidebar?
      this.sidebarModel = false;
    },
    handleCloseSideBar() {
      this.sidebarModel = false;
    }
  },
  data() {
    return {
      noteColor: "yellow",
      noteColor2:
        this.settings &&
        this.settings.user &&
        this.settings.user.noteColor &&
        this.settings.user.noteColor !== undefined
          ? this.settings.user.noteColor
          : "yellow",
      settingsUser: {
        _logNotes:
          this.settings &&
          this.settings.user &&
          this.settings.user._logNotes !== undefined
            ? this.settings.user._logNotes
            : true,
        _logCallRecording:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallRecording !== undefined
            ? this.settings.user._logCallRecording
            : true,
        _logCallType:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallType !== undefined
            ? this.settings.user._logCallType
            : false,
        _logCallOutcome:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallOutcome !== undefined
            ? this.settings.user._logCallOutcome
            : false,
        _logObjective:
          this.settings &&
          this.settings.user &&
          this.settings.user._logObjective !== undefined
            ? this.settings.user._logObjective
            : false,
        _logRefNum:
          this.settings &&
          this.settings.user &&
          this.settings.user._logRefNum !== undefined
            ? this.settings.user._logRefNum
            : false,
        _logCallStatus:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallStatus !== undefined
            ? this.settings.user._logCallStatus
            : false,
        _logCallLocation:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallLocation !== undefined
            ? this.settings.user._logCallLocation
            : false,
        _logCallPriority:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallPriority !== undefined
            ? this.settings.user._logCallPriority
            : false,
        _logContactName:
          this.settings &&
          this.settings.user &&
          this.settings.user._logContactName !== undefined
            ? this.settings.user._logContactName
            : false,
        _logFollowUpDate:
          this.settings &&
          this.settings.user &&
          this.settings.user._logFollowUpDate !== undefined
            ? this.settings.user._logFollowUpDate
            : false,
        _logCallSource:
          this.settings &&
          this.settings.user &&
          this.settings.user._logCallSource !== undefined
            ? this.settings.user._logCallSource
            : false
      },
      assetsURLHome: "",
      toDoMethodologiesJSON,
      storeItemsAudioJSON,
      sidebarId: "settings-sidebar",
      sidebarModel: false,
      modalImageAddId: "photoadd",
      intervalMin: 2,
      intervalMax: 100,
      toggles: [
        {
          name: "stats",
          description:
            "A free-form text field where you can add additional details or " +
            "comments about the call, such as action items," +
            " follow-up tasks, or important information discussed during the call.",
          property: "_showStats",
          type: "btns",
          text: "Display Stats",
          isAvail: true,
          value: true
        },
        {
          name: "description",
          description:
            "A free-form text field where you can add additional details or " +
            "comments about the call, such as action items," +
            " follow-up tasks, or important information discussed during the call.",
          property: "_hasDescription",
          type: "btns",
          text: "Description",
          isAvail: true,
          value: true
        },
        {
          name: "reminder",
          description:
            "In-app recording audio of the call, if it was recorded. It is up to you to abide" +
            " by the laws in your state. Protocol is to announce that the call will be recorded.",
          property: "_hasReminder",
          type: "btns",
          text: "Reminder",
          isAvail: true,
          value: true
        },
        {
          name: "dueDate",
          description:
            "This field may include information about whether the call was" +
            " incoming (received) or out (made).",
          property: "_hasDueDate",
          type: "btns",
          text: "Due Date",
          isAvail: true,
          value: false
        },
        {
          name: "urgency",
          description:
            "A description of the result or purpose of the call, such as " +
            '"answered," "missed," "voicemail left," "call back requested," or "appointment scheduled."',
          property: "_hasUrgency",
          type: "btns",
          text: "Urgency (Level)",
          isAvail: true,
          value: false
        },
        {
          name: "size",
          description:
            "A brief description of the call's purpose or topic, which can be useful for categorizing calls",
          property: "_hasSize",
          type: "btns",
          text: "Size",
          isAvail: true,
          value: false
        },
        {
          name: "privacy",
          description:
            "A unique identifier for the call, which can be helpful for" +
            " tracking and referencing specific calls.",
          property: "_hasPrivacy",
          type: "btns",
          text: "Privacy/Visibility",
          isAvail: true,
          value: false
        },
        {
          name: "tags",
          description: "",
          property: "_hasTags",
          type: "btns",
          text: "Tags",
          isAvail: true,
          value: false
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped></style>
